import { registerSuperProperties, getSuperProperties } from '@hbf/analytics';

const FBC_KEY = 'fbc';

/**
 * FBC is a parameter of facebook which needs to be sent with every event. This parameter is then used by facebook
 * to advertise better and effectively manage the campaigns
 */
export function storeFBCInSuperProperties(): void {
  try {
    if (typeof window === 'undefined') {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');

    if (!fbclid) {
      return;
    }
    const currentSuperProperties = getSuperProperties();

    if (
      typeof currentSuperProperties?.[FBC_KEY] === 'string' &&
      currentSuperProperties[FBC_KEY].endsWith(fbclid)
    ) {
      return;
    }

    registerSuperProperties({ [FBC_KEY]: `fb.1.${Date.now()}.${fbclid}` });
  } catch {
    // ignore
  }
}
